import { createContext } from "react";

export const EditProfileContext = createContext();
